<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Ülke</label>
            <v-validator :errors="errors" parameter="CountryId" :watch="country">
                <v-select-list v-model="country" placeholder="Ülke" label="Name" :options="countries"/>
            </v-validator>
        </div>  
        <div class="col-12 mb-1">
            <label class="form-label">Vize</label>
            <v-validator :errors="errors" parameter="VisaTypeId" :watch="type">
                <v-select-list v-model="type" placeholder="Vize" label="Name" :options="types"/>
            </v-validator>
        </div>  
        <div class="col-12 mb-1">
            <label class="form-label">Başlanıç Tarihi</label>
            <v-validator :errors="errors" parameter="StartDate" :watch="type">
                <v-date-picker v-model="value.StartDate" placeholder="Başlanıç Tarihi"/> 
            </v-validator>
        </div>  
        <div class="col-12">
            <label class="form-label">Bitiş Tarihi</label>
            <v-validator :errors="errors" parameter="EndDate" :watch="type">
                <v-date-picker v-model="value.EndDate" placeholder="Bitiş Tarihi"/> 
            </v-validator>
        </div>  
    </div>
</template>

<script>
import SystemDataApi from '@/api/system-data'

export default {
    props:{
        value:Object,
        errors:Object
    },
    data(){
        return{
            countries:[],
            types:[]
        }
    },
    mounted(){
        this.getCountries()
        this.getVisaType()
    },
    methods:{
        getCountries(){
            SystemDataApi.Country().then(res=>{
                this.countries = res.data.Data
            })
        },
        getVisaType(){
            SystemDataApi.VisaType().then(res=>{
                this.types = res.data.Data
            })
        }
    },
    computed:{
        type:{
            get:function(){
                return this.types.find(b=>b.Id==this.value.VisaTypeId)
            },
            set:function(value){
                this.value.VisaTypeId = value?.Id || null
                this.value.VisaTypeName = value?.Name
            }
        },
        country:{
            get:function(){
                return this.countries.find(b=>b.Id==this.value.CountryId)
            },
            set:function(value){
                this.value.CountryId = value?.Id || null
                this.value.CountryName = value?.Name
            }
        },
    }
}
</script>

<style>

</style>